<rask-map-popup-content [abort]="handleAbort" [canEdit]="canEdit" [edit]="handleEdit" [delete]="handleDelete">
    <ng-container header>{{header}}</ng-container>
    <rask-input label="Figurareal" [readonly]="true"
        value="{{figurAreal | number: '1.0-0'}} ha"></rask-input>
</rask-map-popup-content>